import React, {ChangeEvent, FC} from 'react';
import { Buttons, Form, FormElements } from '../../../common/AddEditFormLayout/AddEditFormLayout.styles';
import {
    DropdownWrapperLarge,
    DropdownWrapperMedium,
} from '../../../common/FormElementWrappers/FormElementWrappers.styles';
import Header from '../../../common/Header/Header';
import { H2 } from '../../../common/Headings/Headings.styles';
import Button from '../../../components/Button/Button';
import Dropdown from '../../../components/Dropdown/Dropdown';
import {RowWrapper } from './ClassBaseForm.styles';
import { ClassBaseFormProps} from './ClassBaseForm.types';
import {OPTIONS_PLACEHOLDER} from "../../../constants/Dropdown";
import {useGetClasses} from "../../../services/class/class.service";
import {Class} from "../../../services/class/class.types";
import {useGetBases} from "../../../services/base/base.service";
import {Base} from "../../../services/base/base.types";
import { HorizontalLine } from '../../Classes/ClassForm/ClassForm.styles';
import ImageForm from '../../../components/ImageForm/ImageForm';

const ClassBaseForm: FC<ClassBaseFormProps> = ({
                                           headerTitle,
                                           formValues,
                                           formErrors,
                                           setFormErrors,
                                           setFormValues,
                                           handleSave,
                                           saveDisabled,
                                           isButtonLoading,
                                           isFormReadOnly = false,
                                           hasImageForm = false,
                                       }) => {

    // fetch classes and map to dropdown options
    const { data: classesData } = useGetClasses();
    const allClasses = classesData?.data || [];
    const classOptions = allClasses.map((item: Class) => {
        return { value: item?.classNo?.toString(), label: `${item?.classNo} - ${item?.description}` };
    });

    // fetch bases and map to dropdown options
    const { data: basesData } = useGetBases();
    const allBases = basesData?.data || [];
    const baseOptions = allBases.map((item: Base) => {
        return { value: item?.baseNo?.toString(), label: `${item?.baseNo} - ${item?.description}` };
    });
    const handleDropDown = (event: ChangeEvent<HTMLSelectElement>) => {
        setFormValues({ ...formValues, [event.target.id]: event.target.value });
        setFormErrors && setFormErrors({ ...formErrors, [event.target.id]: '' });
    };

    return (
        <>
            <Header
                breadcrumb={{label: 'Back to ClassBase Table', to: '/tables/classbases'}}
                title={headerTitle}
            />
            <Form>
                <FormElements>
                    <H2>ClassBase Table</H2>
                    <RowWrapper>
                        <DropdownWrapperMedium>
                            <Dropdown
                                label='MOA Class Number'
                                id='classNo'
                                dataTestId='classDropdown'
                                options={classOptions}
                                value={formValues?.classNo?.toString() || OPTIONS_PLACEHOLDER}
                                errorText={formErrors?.classNo}
                                onChange={handleDropDown}
                                disabled={isFormReadOnly}
                            />
                        </DropdownWrapperMedium>
                    </RowWrapper>
                    <RowWrapper>
                        <DropdownWrapperLarge>
                            <Dropdown
                                label='MOA Base Number'
                                id='baseNo'
                                dataTestId='baseDropdown'
                                options={baseOptions}
                                value={formValues?.baseNo?.toString() || OPTIONS_PLACEHOLDER}
                                errorText={formErrors?.baseNo}
                                onChange={handleDropDown}
                                disabled={isFormReadOnly}
                            />
                        </DropdownWrapperLarge>
                    </RowWrapper>
                  { formValues.classNo && formValues.baseNo && hasImageForm &&
                    <>
                      <HorizontalLine />
                      <ImageForm resourceNo={[formValues.classNo, formValues.baseNo]} attribute="base" />
                    </>
                  }
                </FormElements>
              { !hasImageForm &&
                <Buttons>
                  <Button testId='saveNewClassBaseButton' label='Save' onClick={handleSave} disabled={saveDisabled} isLoading={isButtonLoading}/>
                </Buttons>
              }
            </Form>
        </>
    );
};

export default ClassBaseForm;
